var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value && _vm.item.InfoType__c)?_c('v-icon',{on:{"click":function($event){$event.stopPropagation();return _vm.openLink(_vm.item)}}},[_vm._v(" mdi-open-in-new ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }